module.exports = __webpack_public_path__ + "img/gas-old.a47e2707.png";